/**
 * Catálogo de metadatos de los badges que concede el SERVIDOR v1 (F3-C). El id
 * (badge_award.badge_id) es la clave estable; la UI resuelve título/descripción/
 * emoji desde aquí (los textos se traducen en la capa web con `msg`).
 */

export interface BadgeMeta {
  id: string;
  /** Clave i18n estable (la web mapea a `msg`). */
  titleKey: string;
  descriptionKey: string;
  /** Emoji del kit de gamificación (visual ligero, theme-agnóstico). */
  emoji: string;
}

export const BADGE_FIRST_ENROLLMENT = "first_enrollment";
export const BADGE_FORUM_FIRST_POST = "forum_first_post";
export const BADGE_STREAK_7 = "streak_7";

export const BADGE_CATALOG: Record<string, BadgeMeta> = {
  [BADGE_FIRST_ENROLLMENT]: {
    id: BADGE_FIRST_ENROLLMENT,
    titleKey: "badge.first_enrollment.title",
    descriptionKey: "badge.first_enrollment.description",
    emoji: "🎓",
  },
  [BADGE_FORUM_FIRST_POST]: {
    id: BADGE_FORUM_FIRST_POST,
    titleKey: "badge.forum_first_post.title",
    descriptionKey: "badge.forum_first_post.description",
    emoji: "💬",
  },
  [BADGE_STREAK_7]: {
    id: BADGE_STREAK_7,
    titleKey: "badge.streak_7.title",
    descriptionKey: "badge.streak_7.description",
    emoji: "🔥",
  },
};

/** Metadatos de un badge (fallback genérico si el id es desconocido). */
export function badgeMeta(badgeId: string): BadgeMeta {
  return (
    BADGE_CATALOG[badgeId] ?? {
      id: badgeId,
      titleKey: "badge.unknown.title",
      descriptionKey: "badge.unknown.description",
      emoji: "🏅",
    }
  );
}
